import { Box, Container, Typography } from '@mui/material';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMerchantId } from 'redux/reducers/auth/selectors';
import { get2FAStatusRequest } from 'redux/reducers/settings/reducer';
import { ChangePassword } from './ChangePassword';
import { Enable2FA } from './Enable2FA';

export const SecuritySettings: FC = () => {
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(get2FAStatusRequest());
	}, [dispatch]);

	return (
		<Container>
			<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
				<Typography
					component="h1"
					color="primary"
					sx={{ fontSize: '1.3rem', fontWeight: 'bold', marginBottom: 3, marginTop: 3 }}
				>
					Security Settings
				</Typography>

				{/* <Typography
						variant="h5"
						sx={{ fontWeight: 'bold', marginBottom: 3, marginTop: 3, color: 'gray' }}
					>
						Merchant #{xMerchantId}
					</Typography> */}
			</Box>
			<Box
				sx={{
					display: { md: 'grid', xs: 'flex' },
					flexDirection: 'column',
					gridTemplateColumns: {
						xs: 'repeat(auto-fit, minmax(360px, 1fr))',
						sm: 'repeat(auto-fit, minmax(360px, 1fr))',
						// sm: 'repeat(auto-fill, minmax(380px, 1fr))',
					},

					gridGap: '2rem',
					marginBottom: '20px',
					gridTemplateRows: 'repeat(6, auto-fit)',
					// gridGap: '1rem',
					gridAutoFlow: 'row dense',
				}}
			>
				<ChangePassword />
				<Enable2FA />
			</Box>
		</Container>
	);
};
